import styled from 'styled-components'
import tw from 'twin.macro'

export const CareerFormHeader = styled.h6`
  margin-bottom: 1rem !important;
  ${tw`text-lg text-black w-full font-display px-4 text-center`}
`
